export default function LeftArrow({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg
        width="14"
        height="12"
        viewBox="0 0 14 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.125 5.8125H0.75M0.75 5.8125L5.8125 0.75M0.75 5.8125L5.8125 10.875"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
